export const DEFAULT_PER_PAGE_FAQ_LANDING = 50;

export const GET_FAQ_LANDING = 'get_faq_landing';
